window.refreshThemeCart = async function ({ openDrawer = true } = {}) {
  console.group('[Theme Cart Refresh]');
  try {
    const cart =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification');

    if (!cart) return;

    const sections = cart.getSectionsToRender().map((s) => s.id);

    const body = JSON.stringify({
      updates: {}, // <-- NO-OP update
      sections,
      sections_url: window.location.pathname,
    });

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body,
    });

    const data = await response.json();
    if (!data.sections) return;

    // Render updated sections
    cart.renderContents(data, false);

    // Normalize empty → non-empty state
    cart.classList.remove('is-empty');

    const emptyInner = cart.querySelector('.drawer__inner-empty');
    if (emptyInner) emptyInner.remove();

    const inner = cart.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');

    // Open after DOM settles
    if (openDrawer) {
      requestAnimationFrame(() => cart.open());
    }
  } catch (err) {
    console.error('Error during Theme cart refresh:', err);
  } finally {
    console.groupEnd();
  }
};
